var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "task-box", on: { click: _vm.click } }, [
      _vm._m(0),
      _c("div", { staticClass: "header-title" }, [_vm._v("下载")]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "message-wrapper",
        on: { click: _vm.click },
      },
      [
        _c("div", { staticClass: "message-box" }, [
          _c(
            "div",
            {
              staticClass: "message-main",
              class: _vm.showTask ? "" : "short-message",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.onNoClick.apply(null, arguments)
                },
              },
            },
            [
              _vm.showTask
                ? _c("div", { staticClass: "ewm-block" }, [
                    _c("span", { staticClass: "title-span" }, [
                      _c("img", { attrs: { src: _vm.appLogo } }),
                      _c("em", [_vm._v("扫码下载" + _vm._s(_vm.appName))]),
                    ]),
                    _c("div", [
                      _c(
                        "span",
                        { staticClass: "ewm-block-img" },
                        [
                          _c("AppQrcode", {
                            staticClass: "qrcode",
                            attrs: { size: 120, margin: 0, src: _vm.iosUrl },
                          }),
                          _c("p", [_vm._v("iOS 下载")]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "line-block" }),
                      _c(
                        "span",
                        { staticClass: "ewm-block-img" },
                        [
                          _c("AppQrcode", {
                            staticClass: "qrcode",
                            attrs: {
                              size: 120,
                              margin: 0,
                              src: _vm.androidUrl,
                            },
                          }),
                          _c("p", [_vm._v("Android 下载")]),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "download-block" }, [
                _c("span", { staticClass: "title-span" }, [
                  _vm.orgInfo && _vm.orgInfo.organizationId === 100000
                    ? _c("img", {
                        attrs: {
                          src: "https://oss.hcbnjyai.com/images/loginLogo.png",
                        },
                      })
                    : _c("img", {
                        attrs: {
                          src: require("../../assets/image/account/icn_fuxiyun_new.jpg"),
                        },
                      }),
                  _c("em", { staticStyle: { color: "#ff9f1f" } }, [
                    _vm._v("下载" + _vm._s(_vm.title) + "自媒体客户端"),
                  ]),
                ]),
                _c("div", { staticClass: "icn_down_img" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/image/account/icon_mac_download_new.png"),
                    },
                    on: { click: _vm.downloadDoc },
                  }),
                  _c("img", {
                    staticStyle: { "margin-left": "8px" },
                    attrs: {
                      src: require("../../assets/image/account/icon_windows_download_new.png"),
                    },
                    on: { click: _vm.downloadAndriod },
                  }),
                ]),
              ]),
              _c("div", { staticClass: "download-block" }, [
                _c("span", { staticClass: "title-span" }, [
                  _c("img", { attrs: { src: _vm.loginLogo } }),
                  _c("em", [_vm._v("下载" + _vm._s(_vm.title) + "直播客户端")]),
                ]),
                _c("div", { staticClass: "icn_down_img fl" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/image/account/livemacdown.png"),
                    },
                    on: { click: _vm.downLiveMacTools },
                  }),
                  _c("img", {
                    staticStyle: { "margin-left": "8px" },
                    attrs: {
                      src: require("../../assets/image/account/livewindowsdown.png"),
                    },
                    on: { click: _vm.downLiveWindowTools },
                  }),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-task" }, [
      _c("em", { staticClass: "download-img" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }